export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-queue/src/array.js
// module id = 1351
// module chunks = 0